/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ProjectDocumentVM { 
    id?: number;
    projectId?: number;
    title?: string | null;
    description?: string | null;
    createdDate?: string;
    createdBy?: number;
    updateDate?: string;
    recordType?: string | null;
    documentType?: string | null;
    url?: string | null;
    updatedBy?: number;
    projectName?: string | null;
}

